'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = function (props) {
  var _classname;

  var entityKey = props.entityKey;

  var data = _draftJs.Entity.get(entityKey).getData();
  var emoji = data.emoji;

  var className = (0, _classnames2["default"])((_classname = {}, _defineProperty(_classname, 'emoji', true), _defineProperty(_classname, 'emoji-' + emoji.shortCut, true), _classname));
  var emojiStyle = _extends({}, iconStyle, { backgroundImage: 'url(\'' + emoji.url + '\')' });
  return _react2["default"].createElement(
    'span',
    { style: emojiStyle, contentEditable: false, className: className },
    props.children
  );
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _draftJs = require('draft-js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var emojiRex = /\[([\u4e00-\u9fa5])+\]/g;

var iconStyle = {
  letterSpacing: 32,
  width: 32,
  fontSize: 32,
  height: 32,
  display: 'inline-block',
  backgroundSize: '100%',
  overflow: 'hidden'
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-emoji@0.2.9@rc-editor-plugin-emoji/lib/EmojiIcon.js
// module id = 218
// module chunks = 0 1 2